import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

const sizeOptions = [
  ...Array.from({ length: 13 }, (_, index) => `age ${index + 2}-${index + 3}`),
  'XS', 'S', 'M', 'L', 'XL', 'XXL', 'One Size',
];

export default function ProductSizeEditor({ sizes, onChange, label }) {
  const id = label.toLowerCase().replace(/\s+/g, '-');
  const updateSize = (index, field, value) =>
    onChange(sizes.map((entry, i) => i === index ? { ...entry, [field]: value } : entry));

  return (
    <fieldset className="mb-3">
      <legend className="fs-6">{label} sizes</legend>
      {sizes.map((entry, index) => (
        <div key={index} className="border rounded p-2 mb-2">
          <Form.Label htmlFor={`${id}-size-${index}`}>Size</Form.Label>
          <Form.Select
            id={`${id}-size-${index}`}
            value={entry.size}
            onChange={(event) => updateSize(index, 'size', event.target.value)}
            required
          >
            {sizeOptions.map((size) => (
              <option
                key={size}
                disabled={sizes.some((other, i) => i !== index && other.size === size)}
              >
                {size}
              </option>
            ))}
          </Form.Select>
          <Form.Label htmlFor={`${id}-stock-${index}`}>Stock</Form.Label>
          <Form.Control
            id={`${id}-stock-${index}`}
            type="number"
            min="0"
            step="1"
            value={entry.countInStock}
            onChange={(event) => updateSize(index, 'countInStock', event.target.value)}
            required
          />
          <Form.Label htmlFor={`${id}-price-${index}`}>Price (EGP, optional override)</Form.Label>
          <Form.Control
            id={`${id}-price-${index}`}
            type="number"
            min="0"
            step="0.01"
            value={entry.price ?? ''}
            onChange={(event) => updateSize(
              index, 'price', event.target.value === '' ? undefined : Number(event.target.value)
            )}
            placeholder="Uses sale price or base price when empty"
          />
          <Button
            type="button"
            variant="outline-danger"
            className="mt-2"
            onClick={() => onChange(sizes.filter((_, i) => i !== index))}
          >
            Remove Size
          </Button>
        </div>
      ))}
      <Button
        type="button"
        disabled={sizes.length === sizeOptions.length}
        onClick={() => onChange([
          ...sizes,
          { size: sizeOptions.find((size) => !sizes.some((entry) => entry.size === size)), countInStock: 0 },
        ])}
      >
        + Add Size
      </Button>
    </fieldset>
  );
}
